<template>
  <card v-if="color" :overflow-off="false" :class="['theme-colors-creator']">
    <card-title color="white" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness">
      <table-layout y-align="middle">
        <row>
          <cell v-html="$lang.themeColorsCreator" />
          <cell x-align="right">
            <icon @click="init" name="refresh" :class="['cursor-pointer']" :title="$lang.createThemeColors" />
          </cell>
        </row>
      </table-layout>
    </card-title>
    <card-text>
      <table-layout equal-cells y-align="middle">
        <row>
          <cell>
            <color-picker @input="getColorScheme" v-model="color" icon="format-color-fill" />
            <dropdown @change="getColorScheme" v-model="mode" icon="view-dashboard" :hint="$lang.colorMode.toUpperCase()" :hint-color="$dark ? 'white' : 'black'" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :items="modes" />
          </cell>
          <cell v-if="colorImage" x-align="center">
            <img :src="colorImage" :class="['inline-block', 'color-image', 'shadow-lg']" />
          </cell>
        </row>
      </table-layout>
    </card-text>
    <divider />
    <card-actions align="center">
      <flex>
        <flex-col md6 sm12 xs24 v-if="Object.keys(themeColors)" :span="3" v-for="(value, color) in themeColors" :key="color">
          <container :class="['p-2']">
            <btn block color="white" :bold="false" :uppercase="false" size="xs" :bg-color="color" :bg-color-lightness="500" :title="value" :style="{backgroundColor: value}" >
              <code>
                <span v-html="color" :class="['block']" />
                <span v-html="value" :class="['block']" />
              </code>
            </btn>
          </container>
        </flex-col>
      </flex>
    </card-actions>
    <divider />
    <card-actions align="center">
      <code-chunk :pre="false">{{ themeColors }}</code-chunk>
    </card-actions>
    <divider />
    <card-actions>
      <table-layout y-align="middle">
        <row>
          <cell>
            <a rel="noopener" target="_blank" v-html="apiLabel()" :href="api" :title="apiLabel()" :class="['text-xs', 'opacity-50']" />
          </cell>
          <cell x-align="right">
            <btn @click="init" size="sm" color="white" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" :title="$lang.createThemeColors">{{ $lang.createThemeColors }}</btn>
          </cell>
        </row>
      </table-layout>
    </card-actions>
    <theme-colors ref="theme-colors" />
  </card>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'ThemeColorsCreator',
  mixins: [
    methods
  ],
  data () {
    return {
      color: null,
      swatches: [],
      mode: ['analogic'],
      themeColors: {},
      colorImage: null,
      api: 'https://www.thecolorapi.com'
    }
  },
  props: {
    count: {
      type: Number,
      default: 8
    },
    modes: {
      type: Array,
      default () {
        return ['analogic', 'analogic-complement', 'complement', 'monochrome', 'monochrome-dark', 'monochrome-light', 'quad', 'triad'].map(value => {
          return {value, text: value}
        })
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.color = this.random()
      this.getColorScheme()
    },
    random () {
      return '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0').toUpperCase()
    },
    apiLabel () {
      return this.api.replace('https://www.', '')
    },
    getColorScheme () {
      this.$http({
        url: `${this.api}/scheme`,
        method: 'GET',
        params: {
          count: this.count,
          mode: this.mode[0],
          hex: this.color.replace('#', '')
        }
      }).then(response => {
        this.colorImage = response.data.image.bare
        this.processColors(response.data.colors)
      })
    },
    label (color, lightness) {
      return `${color}${lightness ? ':' + lightness : ' (500)'}`
    },
    processColors (colors) {
      const themeColors = {}
      this.swatches = Object.keys(this.$refs['theme-colors'].colors).map(name => {
        return {name, color: null}
      })
      Object.keys(colors).forEach(index => {
        this.swatches[index].color = colors[index].hex.value.toLowerCase()
      })
      this.swatches.forEach(swatch => {
        themeColors[swatch.name] = swatch.color
      })
      this.themeColors = themeColors
    }
  }
}
</script>
<style>
.theme-colors-creator .color-image
{
  transform: rotate(-90deg);
}
</style>



// WEBPACK FOOTER //
// src/components/theme-colors-creator.vue